module.exports = __webpack_public_path__ + "static/img/logo-login.2ae6d12d.svg";